import { render } from "./AddBonRetourPage.vue?vue&type=template&id=30cb64a3&ts=true"
import script from "./AddBonRetourPage.vue?vue&type=script&lang=ts"
export * from "./AddBonRetourPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__